// console.log(process.env,'===========>process.env')
let host;
if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost:9000';
    // host = 'http://103.25.36.201:30002';
} else {
    // host = 'http://59.110.10.100:80';
    // host = 'http://103.25.36.201:30002';
  host = 'http://localhost:9000';
}

export default {
    // baseUrl: host + '/api/mock/1bMHnKKlV21/musa', // host +
    baseUrl: host, // 测试环境
    hostUrl: host,
}



// WEBPACK FOOTER //
// ./src/config/urlConfig.js